import script from "./Reader.vue?vue&type=script&setup=true&lang=js"
export * from "./Reader.vue?vue&type=script&setup=true&lang=js"

import "./Reader.vue?vue&type=style&index=0&id=49bdf3e1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49bdf3e1"]])

export default __exports__